// Supported display currencies (prices are stored/charged in USD; these are for display only).
export const SUPPORTED = [
  { code: "USD", name: "US Dollar" },
  { code: "EUR", name: "Euro" },
  { code: "GBP", name: "British Pound" },
  { code: "NGN", name: "Nigerian Naira" },
  { code: "GHS", name: "Ghanaian Cedi" },
  { code: "CAD", name: "Canadian Dollar" },
  { code: "AUD", name: "Australian Dollar" },
  { code: "ZAR", name: "South African Rand" },
  { code: "KES", name: "Kenyan Shilling" },
  { code: "XOF", name: "West African CFA" },
  { code: "EGP", name: "Egyptian Pound" },
  { code: "AED", name: "UAE Dirham" },
  { code: "INR", name: "Indian Rupee" },
  { code: "JPY", name: "Japanese Yen" },
  { code: "CNY", name: "Chinese Yuan" },
  { code: "BRL", name: "Brazilian Real" },
  { code: "JMD", name: "Jamaican Dollar" },
  { code: "TTD", name: "Trinidad & Tobago Dollar" },
];

export const SUPPORTED_CODES = SUPPORTED.map((c) => c.code);

// Minimal country -> currency map for auto-detection from the browser locale region.
const COUNTRY_CURRENCY = {
  US: "USD", GB: "GBP", NG: "NGN", GH: "GHS", CA: "CAD", AU: "AUD",
  ZA: "ZAR", KE: "KES", EG: "EGP", AE: "AED", IN: "INR", JP: "JPY",
  CN: "CNY", BR: "BRL", JM: "JMD", TT: "TTD",
  IE: "EUR", DE: "EUR", FR: "EUR", ES: "EUR", IT: "EUR", NL: "EUR", PT: "EUR",
  SN: "XOF", CI: "XOF", ML: "XOF", BJ: "XOF", TG: "XOF", BF: "XOF",
};

export function detectCurrency() {
  try {
    const saved = localStorage.getItem("shop_currency");
    if (saved && SUPPORTED_CODES.includes(saved)) return saved;
  } catch (e) { /* ignore */ }
  try {
    const langs = navigator.languages || [navigator.language];
    for (const l of langs) {
      const region = (l.split("-")[1] || "").toUpperCase();
      if (region && COUNTRY_CURRENCY[region] && SUPPORTED_CODES.includes(COUNTRY_CURRENCY[region])) {
        return COUNTRY_CURRENCY[region];
      }
    }
  } catch (e) { /* ignore */ }
  return "USD";
}

export function formatMoney(amount, code) {
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: code,
      currencyDisplay: "narrowSymbol",
    }).format(amount);
  } catch (e) {
    return `${code} ${amount.toFixed(2)}`;
  }
}
